/**
 * Preferences service for CRUD operations on user_preferences
 */

import { supabase } from './supabase';

/**
 * Preferences service object with all database operations
 */
export const preferencesService = {
  /**
   * Fetches preferences for the current user
   * @returns {Promise<Object|null>} User preferences or null if not set
   */
  async getPreferences() {
    const { data, error } = await supabase
      .from('user_preferences')
      .select('*')
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  /**
   * Creates or updates preferences for the current user
   * @param {Object} preferences - Preference fields to save
   * @returns {Promise<Object>} Saved preferences
   */
  async upsertPreferences(preferences) {
    const { data: { user } } = await supabase.auth.getUser();

    const { data, error } = await supabase
      .from('user_preferences')
      .upsert(
        { ...preferences, user_id: user.id },
        { onConflict: 'user_id' }
      )
      .select()
      .single();

    if (error) throw error;
    return data;
  }
};
